import { SyntheticEvent, useCallback } from "react";

type Props = {
  onClose: () => void;
};

const useManageModal = ({ onClose }: Props) => {
  const handleCloseClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleContainerClick = useCallback((event: SyntheticEvent) => {
    event.stopPropagation();
  }, []);

  return { handleCloseClick, handleContainerClick };
};

export default useManageModal;
